module.exports = __webpack_public_path__ + "static/media/panDob.fcc992bf.svg";